import { PlainDatatypes } from '../../../datatype/Datatype';
import { createConditionOperator } from '../IConditionOperator';

export const ConditionOperatorNotInType = createConditionOperator({
  code: 'notIn',
  label: 'non in',
  description: 'Non è uno di',
  args: [
    {
      type: 'referenceValue',
      isArray: true,
    },
  ],
  allowsField: field => PlainDatatypes.includes(field.type),
  compare(value: any, [list]: [any[]]) {
    // Se la lista è vuota, allora il valore non può essere contenuto,
    // quindi ritorna true
    if (list == null) return true;

    return !list.includes(value);
  },
});
